import { entryInterestIds } from '@shared/lineupActs'
import type { LineupEntry } from '../../../types'

/**
 * The lineup's artists in `hintIds` (followed, not yet hearted here), distinct
 * and in lineup order — act performers and a named collab each count once.
 */
export function followedNotPicked(lineup: LineupEntry[], hintIds: ReadonlySet<string>): string[] {
  if (hintIds.size === 0) return []
  const ids = new Set<string>()
  for (const entry of lineup) {
    for (const id of entryInterestIds(entry)) if (hintIds.has(id)) ids.add(id)
  }
  return [...ids]
}
